import styled from "styled-components"

export const SearchFoodsWrapper = styled.div`
  height: 100%;
  background-color: #fff;
`

export const SearchFoodsContent = styled.div`
  --header-height: 44px;
  --search-bar-height: 46px;

  height: calc(100% - var(--header-height) - var(--search-bar-height));
`
